import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home", end: true },
  { to: "/event", label: "The Event & Itinerary" },
  { to: "/stay", label: "Villa Taina" },
  { to: "/hotels", label: "Other Hotels" },
  { to: "/travel", label: "Travel" },
  { to: "/do", label: "Things to Do" },
  { to: "/whos-going", label: "Who's Going" },
  { to: "/faq", label: "FAQ" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-40 border-b border-shell bg-cream/80 backdrop-blur-md"
      data-testid="main-nav"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 flex items-center justify-between h-16 md:h-20">
        <Link to="/" className="flex items-baseline gap-2 group" data-testid="nav-logo">
          <span className="font-display text-2xl md:text-3xl font-black tracking-tight text-ink group-hover:text-terracotta transition-colors">
            Rach Fest
          </span>
          <span className="font-display italic text-sm text-gold font-bold hidden sm:inline">'27</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) =>
                `animated-underline text-sm tracking-wide font-medium transition-colors ${
                  isActive ? "text-terracotta nav-active" : "text-ink hover:text-terracotta"
                }`
              }
              data-testid={`nav-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/rsvp" className="btn-primary h-10 text-sm px-5" data-testid="nav-rsvp-btn">
            RSVP
          </Link>
        </nav>

        <button
          className="lg:hidden p-2 -mr-2 text-ink"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          data-testid="nav-hamburger"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-shell bg-cream" data-testid="nav-mobile">
          <div className="px-5 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `text-lg font-medium ${isActive ? "text-terracotta" : "text-ink"}`
                }
                data-testid={`nav-mobile-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/rsvp"
              onClick={() => setOpen(false)}
              className="btn-primary w-full h-12 mt-2"
              data-testid="nav-mobile-rsvp-btn"
            >
              RSVP
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
